export const publicPath = (path: string): string => {
  const normalizedBaseUrl = import.meta.env.BASE_URL.replace(/\/+$/, '')
  const normalizedPath = path.replace(/^\/+/, '')
  return `${normalizedBaseUrl}/${normalizedPath}`
}
